import React, { useState, useCallback } from "react";
import EndcustomerArticleForm from "Components/Article/EndcustomerArticleForm";
import { useNavigate } from "react-router-dom";
import Paper from "Components/UI/Paper";
import DeleteDialog from "Components/UI/Dialogs/DeleteDialog";
import useDeleteDialog from "Components/UI/Dialogs/useDeleteDialog";
import usePost from "Hooks/usePost";
import { updateEndcustomerArticle } from "API/swesum";

//MUI
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";

import EndcustomerArticleFormSystem from "Components/Article/EndcustomerArticleFormSystem";
import { usePayRules } from "Context/PayRules";
import { useAccountCharts } from "Context/AccountCharts";
import { usePopupNotificationContext } from "Context/NotificationPopup";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function EndcustomerArticleCard({ endcustomerArticle }) {
  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };
  const { payRules, payTypes } = usePayRules();
  const [formData, setFormData] = useState({
    Id: endcustomerArticle.Id,
    Name: endcustomerArticle.Name ? endcustomerArticle.Name : "",
    DebitAccountChartId: endcustomerArticle.DebitAccountChartId
      ? endcustomerArticle.DebitAccountChartId
      : null,
    CreditAccountChartId: endcustomerArticle.CreditAccountChartId
      ? endcustomerArticle.CreditAccountChartId
      : null,
    VAT: endcustomerArticle.VAT ? endcustomerArticle.VAT : 0,
    Payrule: endcustomerArticle.Payrule,
    Paytype: endcustomerArticle.Paytype,
    ParseMessage: endcustomerArticle.ParseMessage,
    ParseStatus: endcustomerArticle.ParseStatus,
    SystemStatus: endcustomerArticle.SystemStatus,
    CreateTime: endcustomerArticle.CreateTime,
  });

  const deleteDialog = useDeleteDialog(false);
  const { openSuccess, openError } = usePopupNotificationContext();
  const navigate = useNavigate();
  const updateClientAccReq = usePost({
    mtnFunc: (body) => {
      return updateEndcustomerArticle(endcustomerArticle.Id, body);
    },
    onSuccess: (data) => {
      openSuccess(`Sparat!`, 3000);
    },
    onError: () => {
      openError("Ett fel har uppstått", 3000);
    },
  });

  const deleteClientAccReq = usePost({
    mtnFunc: (inputs) => {
      return deleteClientAccReq(endcustomerArticle.Id);
    },
    onSuccess: (data) => {
      navigate("/endcustomersarticles");
    },
    onError: () => {
      deleteDialog.close();
      openError("Ett fel har uppstått.", 3000);
    },
  });

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography
              sx={{ marginBottom: "1.0rem" }}
              variant="h5"
              align="left"
            >
              Slutkundsartikelkort
            </Typography>

            <Tabs
              value={tabIndex}
              onChange={handleTabSwitch}
              sx={{ marginBottom: "2rem" }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Allmänt" />
              <Tab label="System" />
            </Tabs>
            <TabPanel value={tabIndex} index={0}>
              <EndcustomerArticleForm
                formData={formData}
                handleInputChange={handleInputChange}
                payRuleOptions={payRules}
                payTypeOptions={payTypes}
              />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
              <EndcustomerArticleFormSystem
                formData={formData}
                handleInputChange={handleInputChange}
              />
            </TabPanel>
            <Grid
              item
              xs={12}
              md={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button onClick={() => navigate(-1)}>Stäng</Button>
              <Button
                onClick={() => updateClientAccReq.post(formData)}
                variant="contained"
                sx={{ ml: 3 }}
              >
                Spara
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <DeleteDialog
        title={"Ta bort slutkundartikel"}
        isOpen={deleteDialog.isOpen}
        handleClose={deleteDialog.close}
        handleDelete={() => deleteClientAccReq.post()}
      >
        Slutkundartikeln kommer att tas bort.
      </DeleteDialog>
    </>
  );
}
